enum phioActionTypes {
    SET_AUTH_STATE = 'SET_AUTH_STATE',
    SET_REGION = 'SET_REGION',
    SET_PATIENT_DATA = 'SET_PATIENT_DATA',
    SET_IS_FIRST_ATTEMPT = 'SET_IS_FIRST_ATTEMPT',
    RESET_PHIO_REDUCER = 'RESET_PHIO_REDUCER',
    SET_MEMBERSHIP = 'SET_MEMBERSHIP',
}

export default phioActionTypes;
